import React, { useEffect, useContext} from 'react';
import Context from "../context/context";

import { checkString, checkArray } from '../helpers/global';
import BookingLink from './performances/BookingLink';

const Event = props => {
  const {availability} = useContext(Context);
  const {data} = props;
  console.log(data)
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};

  const availability_data = availability.find(a => a.event === data.event_hash);
  if (availability_data){
    if (!availability_data.book){
      data.book_link = "";
      data.no_book_link = "true";
    }
  }


  let container_class = "grid-item";
  if (checkString(data.yc_foreign_id)) {
    container_class += " external";

  }

  if (checkArray(data.image_data)){
    img_src = data.image_data.toString();
  }


  img_alt = data.image_alt;

  if (checkArray(data.focal_point)){
    focal_point = data.focal_point;
     combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }

  const openLink = (e) => {
    e.preventDefault();
    if (checkString(data.yc_foreign_id)) {
      window.open(data.url, '_blank');

    } else {
      window.location.href = data.url;

    }
  }


  useEffect(() => {

    if (typeof window.gdVideo != "undefined" ){
      window.gdVideo();
    }
  }, []);

  return (
    <div className={container_class} data-event-hash={data.event_hash}>
      <div className="slot play-container has-modal " >


       {checkString(img_src) &&

         <div className="slot-image">

          <a className="image-container " target={checkString(data.yc_foreign_id) ? '_blank' : '_self'}  href={data.url} >
             {checkString(data.event_quicklinks)  &&
               <div className="quicklinks">{data.event_quicklinks}</div>
             }
              <div className="tags">
              {checkString(data.event_type) &&
                <div className="tag">{data.event_type}</div>
              }
              {checkString(data.festival_tag)  &&
                <div className="event-tag external">{data.festival_tag}</div>
              }
              </div>
              <img loading="lazy" srcset={img_src}  alt={img_alt} style={combiStyle} />



           </a>
         </div>
       }
        <div className="slot-content">
          <a  target={checkString(data.yc_foreign_id) ? '_blank' : '_self'}  href={data.url}  className="slot-title font-m font-title-bold" dangerouslySetInnerHTML={{__html: data.title}} />

          <div className="slot-bottom">
          <div class="slot-info">
            {checkString(data.subtitle) &&
              <div className="slot-artists">{data.subtitle}</div>
            }
            {checkString(data.date_formatted) &&
              <div className="slot-date">{data.date_formatted}</div>
            }
            {checkString(data.venue_name) &&
              <div className="slot-venue">{data.venue_name}</div>
            }
            </div>
            {checkString(data.min_price)  &&
              <div className="slot-price"><b>{data.min_price}</b></div>
            }
            {availability_data  &&
              <div className="slot-availability">{availability_data.status}</div>
            }

          </div>
          <div className="button-wrapper">

            { !data.past_event
              ? checkString(data.priority) && !checkString(data.no_book_link)
                ? <a className="button button-black button-book priority" href={data.url}>
                    Quick Book
                  </a>
                : checkString(data.book_link)
                  ? <a className="button button-black button-book" target={data.book_link_target} href={data.book_link}>
                      {data.book_link_title}
                    </a>
                  : checkString(data.no_book_link)
                    ? null
                    : <BookingLink hash={data.hash} />
              : null
            }
            <a className="button button-white-border " target={checkString(data.yc_foreign_id) ? '_blank' : '_self'} href={data.url} >{data.link_title}</a>
          </div>
        </div>

    </div>
  </div>

  )
}

export default Event;
